import { createSlice } from '@reduxjs/toolkit'
import { CHAT_GROUP_ID, LANGUAGE_ROOM_ID } from 'utils/constants/index'
import { getChats, sendChatMessage } from 'redux-store/thunk/chat.thunk'

const getLocalStorageItem = (key) => {
  try {
    return localStorage.getItem(key) ? parseInt(localStorage.getItem(key)) : null
  } catch {
    return null
  }
}

const setLocalStorageItem = (key, value) => {
  try {
    localStorage.setItem(key, value.toString())
  } catch {
    // Ignore localStorage errors
  }
}

const initialState = {
  chat: null,
  selectedRoomId: getLocalStorageItem(LANGUAGE_ROOM_ID) || 1,
  selectedChatGroupId: getLocalStorageItem(CHAT_GROUP_ID) || 1
}

const {
  actions: {
    setChat,
    setSelectedRoomId,
    setSelectedChatGroupId,
    updateDeletedChat
  },
  reducer
} = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setSelectedChatGroupId: (state, action) => {
      setLocalStorageItem(CHAT_GROUP_ID, action.payload)
      return {
        ...state,
        selectedChatGroupId: action.payload
      }
    },
    setSelectedRoomId: (state, action) => {
      setLocalStorageItem(LANGUAGE_ROOM_ID, action.payload)
      return {
        ...state,
        selectedRoomId: action.payload
      }
    },
    setChat: (state, action) => {
      if (!state.chat) {
        return {
          ...state,
          chat: {
            count: 1,
            rows: [action.payload]
          }
        }
      }
      return {
        ...state,
        chat: {
          count: state.chat.count + 1,
          rows: [...state.chat.rows, action.payload]
        }
      }
    },
    updateDeletedChat: (state, action) => {
      if (!state.chat) return state
      const chatRows = state.chat.rows
      const updatedRows = chatRows.map(msg => {
        if (msg.id == +action.payload.messageId) {
          return {
            ...msg,
            message: '',
            status: 3 // DELETED
          }
        }
        return msg
      })

      return {
        ...state,
        chat: {
          ...state.chat,
          rows: updatedRows
        }
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChats.fulfilled, (state, action) => {
        // Backend returns DESC (newest first), reverse to ASC (oldest first) for display
        const reversedRows = [...action.payload.rows].reverse()
        return {
          ...state,
          chat: { ...action.payload, rows: reversedRows }
        }
      })
      .addCase(sendChatMessage.fulfilled, (state, action) => {
        // Message sent successfully, socket will update the chat
        return state
      })
  }
})

export default reducer
export {
  setChat,
  setSelectedRoomId,
  setSelectedChatGroupId,
  updateDeletedChat
}
